import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { ExternalLeadProduct } from '@tassomutuo-backoffice/types';
import ExternalLeadsList from './ExternalLeadsList';
import ConsultationRequestsList from '../consultationRequests/ConsultationRequestsList';

type ExternalLeadsTab = ExternalLeadProduct | 'consultation';

const VALID_TABS: ExternalLeadsTab[] = [
  'mortgage',
  'loan',
  'cdq',
  'consultation',
];

const TAB_LABEL: Record<ExternalLeadsTab, string> = {
  mortgage: 'Mutui',
  loan: 'Prestiti',
  cdq: 'Cessione del Quinto',
  consultation: 'Consulenze',
};

const ExternalLeadsPage = () => {
  const navigate = useNavigate();
  const { product } = useParams<{ product?: string }>();

  if (!product) {
    return <Navigate to="/admin/external-leads/mortgage" replace />;
  }

  if (!VALID_TABS.includes(product as ExternalLeadsTab)) {
    return <Navigate to="/admin/external-leads/mortgage" replace />;
  }

  const currentTab = product as ExternalLeadsTab;

  const handleTabChange = (_: unknown, next: ExternalLeadsTab) => {
    navigate(`/admin/external-leads/${next}`);
  };

  return (
    <Box>
      <Box px={4} pt={4} pb={2} gap={1} display="flex" alignItems="center">
        <PersonSearchIcon fontSize="large" />
        <Typography variant="h4" fontWeight="bold">
          Lead esterne
        </Typography>
      </Box>

      <Paper elevation={0} sx={{ mx: 4, mb: 2 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          {VALID_TABS.map((p) => (
            <Tab key={p} label={TAB_LABEL[p]} value={p} />
          ))}
        </Tabs>
      </Paper>

      {currentTab === 'consultation' ? (
        <ConsultationRequestsList consultantScope="with-consultant" />
      ) : (
        <ExternalLeadsList key={currentTab} product={currentTab} />
      )}
    </Box>
  );
};

export default ExternalLeadsPage;
